// extracted by mini-css-extract-plugin
export var item = "ff_tm";
export var text = "ff_hx";